'use client';

import React from 'react';
import { StoryblokComponent } from 'gatsby-source-storyblok';

const Contact = ({ content }) => {
  return (
    <div className="w-full rounded-t-2xl bg-yellow-15 pt-0 pb-8">
      <div className="w-full max-w-screen-xl pt-8 mb-0 pl-0 pr-4 md:px-4 flex flex-col sm:flex-row mx-auto">
        {content.contact_blocks.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
      </div>
    </div>
  );
};

export default Contact;
